import axios from "axios";
import { authenticatorApi } from "@/infrastructure/api/authenticatorApi";

type NicheResponse = { id: number; nome: string };

export async function getNiches(categoryId: string) {
  try {
    const { data } = await authenticatorApi.get<NicheResponse[]>(
      `/nichos/categoria/${categoryId}`,
    );
    return data.map((item) => ({ label: item.nome, value: String(item.id) }));
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const detail = error.response?.data?.detail;
      if (typeof detail === "string" && detail) throw new Error(detail);
      if (!error.response) throw new Error("Não foi possível conectar ao servidor.");
    }
    throw new Error("Não foi possível carregar as subcategorias.");
  }
}
